import React, {Component} from 'react';
import {Typography} from 'antd';
import {CopyrightOutlined} from '@ant-design/icons';
import {t} from '../../../constant/i18n';
import {THEME} from '../../../constant/theme';

const {Text} = Typography;

// Reprend le footer du site public : icône ©, mention de copyright puis les
// quatre pages légales. Les libellés suivent la langue de l'espace membre,
// les URLs pointent sur les pages du site (slugs danois pour Vita).
export class FooterApps extends Component {

    render() {
        const links = [
            {url: THEME.urls.privacy, label: t('footer.privacy')},
            {url: THEME.urls.terms, label: t('footer.terms')},
            {url: THEME.urls.legal, label: t('footer.legal')},
            {url: THEME.urls.security, label: t('footer.security')},
        ];

        return (
            <div style={{textAlign: 'center'}}>
                <Text type="secondary">
                    <CopyrightOutlined /> {t('footer.copyright')} -{' '}
                    {links.map((link, i) => (
                        <React.Fragment key={link.url}>
                            {i > 0 && ' | '}
                            <a target="_blank" rel="noopener noreferrer" href={link.url}>{link.label}</a>
                        </React.Fragment>
                    ))}
                </Text>
                <br />
                <br />
            </div>
        )
    }

}
